export default "__VITE_ASSET__DkRGi71O__"